import React, { FC, useState } from 'react';
import MobileMenu from './content/mobile-menu';
import MobileMenuHeader from './content/mobile-menu-header';
import Button from '@/components/atoms/button';
import Drawer from '../drawer';
import { useFormat } from '../hooks/useFormat';
import useHeaderData from '@/lib/tastics/header/hooks/useHeaderData';
import { Option } from '@/components/atoms/select/types';

export interface Props {
  logo: any;
  logoLink: any;
  links: any[];
  showSearchBar?: boolean;
  setShowSearchBar?: any;
  selectedBusinessUnit: string;
  businessUnits: Option[];
  onBusinessUnitChange?: (businessUnit: string) => void;
  isAdmin?: boolean
}

const HeaderNavigationMobile: FC<Props> = ({ links, logo, logoLink, showSearchBar, setShowSearchBar, selectedBusinessUnit, businessUnits, onBusinessUnitChange, isAdmin }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const {
    account,
    onLogoutClick
  } = useHeaderData();
  const [categoriesNavigator, setCategoriesNavigator] = useState<any[]>([]);
  const [showMenu, setShowMenu] = useState(false);

  const showHeaderMenu = () => {
    setShowMenu(true);
    setShowSearchBar(false)
  };

  const hideHeaderMenu = () => {
    setShowMenu(false);
    setCategoriesNavigator([]);
    setShowSearchBar(true)
  };

  const removeCategory = () => {
    setCategoriesNavigator((array) => array.slice(0, -1));
  };

  const insertCategory = (category: any) => {
    setCategoriesNavigator((array) => [...array, category]);
  };

  return (
    <div className="flex lg:hidden">
      <Button
        variant="ghost"
        size="fit"
        onClick={showHeaderMenu}
        title={formatMessage({ id: 'header.menu.open', defaultMessage: 'Open side menu' })}
        className=""
      >
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.25 6.75H20.75M4.25 12H20.75M4.25 17.25H20.75" stroke="#494949" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      </Button>

      <Drawer
        isOpen={showMenu}
        direction="left"
        className="w-full border border-neutral-400 bg-neutral-100"
        onClose={hideHeaderMenu}
      >
        <MobileMenuHeader
          categories={categoriesNavigator}
          hideHeaderMenu={hideHeaderMenu}
          logo={logo}
          logoLink={logoLink}
          onArrowClick={removeCategory}
          showSearchBar={showSearchBar}
          setShowSearchBar={setShowSearchBar}
          name={account?.firstName ?? ''}
        />

        <MobileMenu
          links={links}
          hideHeaderMenu={hideHeaderMenu}
          categoriesNavigator={categoriesNavigator}
          onArrowClick={removeCategory}
          insertCategory={insertCategory}
          onLogoutClick={onLogoutClick}
          selectedBusinessUnit={selectedBusinessUnit}
          businessUnits={businessUnits}
          onBusinessUnitChange={onBusinessUnitChange}
          isAdmin={isAdmin}
        />


        {/* <MobileMenuFooter showMenu={showMenu} hideHeaderMenu={hideHeaderMenu} insertCategory={insertCategory} /> */}
      </Drawer>
    </div>
  );
};

export default HeaderNavigationMobile;